import { render, staticRenderFns } from "./SearchHead.vue?vue&type=template&id=20aad89b"
import script from "./SearchHead.vue?vue&type=script&lang=js"
export * from "./SearchHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports